import * as constants from "../constants";

function PagesAction(code) {
    return{
        type:constants.PAGES_QUICKACCESS,
        payload:code
    }
  }
  export { PagesAction };